import {downloadFileFromResponse, putAll, showBeError, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, select, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {simpleTableSelector, getRequestedTableCsvExportParams} from 'utils/tables';

import {animalBrowserAction, ExportToCsvAction} from '../action';

function* execute({payload}: ExportToCsvAction): SagaIterator {
    yield* put(animalBrowserAction.startExport());
    const tableState = opt(yield* select(simpleTableSelector.tableState('cowBrowser'))).orCrash('no tableState');

    const {sort, fieldParams} = getRequestedTableCsvExportParams(tableState);

    const pathParams = {stableId: payload};

    const response = yield* call(Api.exportBreedingFemales, fieldParams, {sort}, pathParams);
    if (response.isSuccess) {
        yield* call(downloadFileFromResponse, response);
    } else {
        yield putAll(showBeError(response, t('animalBrowser')('exportCows')));
    }
    yield* put(animalBrowserAction.exportFinished());
}

/**
 * Exports the breeding-female browser view as CSV.
 *
 * @returns The saga watcher for `EXPORT_TO_CSV`.
 */
export function* getCowsCsvSaga(): SagaIterator {
    yield takeLatestF('animalBrowser/EXPORT_TO_CSV', execute);
}
